import React from 'react';
import { 
  TransitionMotion as Transition,
  spring
} from 'react-motion'

class SlideShow extends React.Component {
  constructor (props) {
    super (props);

    // Bind this property to functions
    this.hasImages = this.hasImages.bind (this);
    this.setImage = this.setImage.bind (this);
    this.updateImage = this.updateImage.bind (this);

    this.state = {
      active: 0,
      intervalID: undefined
    }

  }

  componentDidMount () {
    if (this.hasImages (2)){
      this.state.intervalID = setInterval (this.updateImage, 4000);
    }
  }

  componentWillUnmount () {
    if (this.state.intervalID) {
      clearInterval (this.state.intervalID);
      this.state.intervalID = undefined;
    }
  }

  hasImages (imageCount = 1) {
    return this.props.imageUrls.length >= imageCount;
  }

  updateImage (){
    let active = this.state.active;
    // If there is next url in the list use that, otherwise the first
    active = this.hasImages (active + 2) ? active + 1 : 0;
    this.setImage (active);
  }

  setImage (imageIndex){
    if (this.props.onImageSet && typeof imageIndex === "function"){
      this.props.onImageSet (this.props.imageUrls [imageIndex])
    }
    this.setState ({
      active: imageIndex
    });
  }

  willLeave () {
    const fadeEffect = { stiffness: 62, damping: 13, precision: .001}
    return { opacity: spring (0, fadeEffect), zIndex: 2 }
  }

  render () {
    let style = {
      key: `${this.state.active}`,
      style: { opacity: 1, zIndex: 1 }
    }

    return (
      <Transition 
        styles={[style]}
        willLeave={this.willLeave}
      >
      { interpolateStyle =>
          <div className="slide-show">
            { interpolateStyle.map (item => {
              const activeImage = {
                backgroundImage: `url(${this.props.imageUrls [parseInt (item.key)]})`,
                opacity: item.style.opacity,
                zIndex: item.style.zIndex
              };
              return <div 
                key={item.key} 
                className="slide-show--slide active" 
                style={activeImage} 
              />
            }

            )}
          </div>
      }
      </Transition>
    );
  }

}

export default SlideShow;


// WEBPACK FOOTER //
// ./components/slide-show/index.js